import React from 'react'
import Printer from '../../../assets/icons/print.png'

export const PrinterIcon = () => <img src={Printer} alt="Ícone impressora" />
